import { render, staticRenderFns } from "./Prestation.vue?vue&type=template&id=3afb09a1&scoped=true"
import script from "./Prestation.vue?vue&type=script&lang=js"
export * from "./Prestation.vue?vue&type=script&lang=js"
import style0 from "./Prestation.vue?vue&type=style&index=0&id=3afb09a1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3afb09a1",
  null
  
)

export default component.exports